import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import ApiClient from '../../helpers/ApiClient';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number, CKEditor} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import AppForm from '../../components/AppForm';
import DeleteButton from '../../components/DeleteButton';
import TableForm from '../../components/TableForm';
import ChangeBar from '../../components/ChangeBar';
import IconCheckbox from '../../components/Form/IconCheckbox';
import HoursInput from '../../components/WeekScheduler';

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'calendar.fetch',
			save: 'calendar.save'
		};

		this.changeEvent = 'calendar.change';

		this.messages = {
			remove: 'Opravdu si přejete den odstranit?',
			notfound: 'Den nenalezen!',
			saved: 'Den byl uložen.'
		};

		this.schema = {
			active: {
				class: IconCheckbox
			},
			hours: {
				class: HoursInput
			},
			notice: {
				class: TextInput
			}
		};
		this.form = new FormManager(this.schema);
	}

	render() {

		const isNew = !this.props.id;
		const canEdit = 1 || this.user.isAllowed('day', isNew ? 'insert' : 'update');
		const data = this.form.getValues().toJS();

		const saveButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={!!(this.props.form && this.props.form.get('saving'))}
			onClick={()=>this.save(true)}
		/>;

		return (
			<AppForm id={this.props.tabid} disableInitRedux={true} form={this.form} ref="form">
				Volný termín: <FormField name="active" />
				<FormField name="hours" />
				<fieldset><legend>Poznámka</legend></fieldset>
				<FormField name="notice" />
				<div className="modal-footer" style={{margin: -20, marginTop: 20}}>
					<Button onClick={() => this.props.onClose()} bsStyle="link">Storno</Button>
					<Button className="hide" onClick={() => this.props.onClose()} bsStyle="success">Export PDF</Button>
					{saveButton}
				</div>
			</AppForm>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/AdminForm.js